import React from 'react';
import paginationHelper from './helpers';
import { Icon } from '../icon';
import { PaginationWrapper, PaginationItem, PaginationNavArrow } from './styled';
const PrevIcon = React.createElement(Icon, { name: "arrow_back" });
const NextIcon = React.createElement(Icon, { name: "arrow_forward" });
const PaginationComponent = ({ siblingCount = 0, boundaryCount = 1, totalPages, currentPage, onPrevPageChange, onNextPageChange, changePage = () => null, ...rest }) => {
    const { itemList } = paginationHelper({
        currentPage,
        totalPages,
        boundaryCount,
        siblingCount
    });
    const rawPagination = itemList.map((page, index) => (React.createElement(PaginationItem, { variant: "outline", onClick: () => changePage(page), text: page.toString(), key: `pagination_${page}_${index}`, isLoading: false, isActive: currentPage === page })));
    const PaginationList = [
        React.createElement(PaginationNavArrow, { variant: "outline", "aria-label": "previous page", key: "pagination_prev_button", disabled: currentPage === 1, onClick: onPrevPageChange, StartIcon: PrevIcon }),
        ...rawPagination,
        React.createElement(PaginationNavArrow, { variant: "outline", "aria-label": "next page", key: "pagination_next_button", disabled: currentPage === totalPages, onClick: onNextPageChange, StartIcon: NextIcon })
    ];
    return React.createElement(PaginationWrapper, null, PaginationList);
};
export default PaginationComponent;
